var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1134 595.2-93.602-19.199-44.398-134.4c-15.602-48-60-79.199-110.4-79.199h-75.602v-69.602c0-24-20.398-44.398-44.398-44.398h-55.199v454.8l-680.4-0.003906v76.801c0 24 20.398 44.398 44.398 44.398h48c0 69.602 57.602 127.2 127.2 127.2 69.602 0 127.2-57.602 127.2-127.2h445.2c0 69.602 57.602 127.2 127.2 127.2 69.602 0 127.2-57.602 127.2-127.2h48c24 0 44.398-20.398 44.398-44.398l0.007812-141.6c1.1992-20.398-13.199-38.398-34.801-43.199zm-884.4 289.2c-33.602 0-60-26.398-60-60 0-33.602 26.398-60 60-60 33.602 0 60 26.398 60 60 0 33.602-26.402 60-60 60zm560.4-320.4v-134.4h75.602c21.602 0 39.602 13.199 46.801 33.602l33.602 100.8zm140.4 320.4c-32.398 0-60-26.398-60-60 0-33.602 27.602-60 60-60 33.602 0 60 26.398 60 60 0 33.602-27.598 60-60 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656.4 248.4h-583.2c-24 0-43.199 19.199-43.199 43.199v358.8h626.4z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.7b1da924153d3a074274c4504d8aa58c.svg";
export { ForwardRef as ReactComponent };